import React from 'react';

type WeeklyLearningGuideNeisLegendProps = {
  className?: string;
};

const WeeklyLearningGuideNeisLegend: React.FC<WeeklyLearningGuideNeisLegendProps> = ({ className }) => (
  <ul
    className={['cp-weekly-learning-guide-neis-legend', className].filter(Boolean).join(' ')}
    aria-label="NEIS 반별시간표 표시 안내"
  >
    <li data-tutorial-neis-legend="diff-track">
      <span
        className="cp-weekly-learning-guide-neis-legend-swatch cp-weekly-learning-guide-neis-legend-swatch--diff-track"
        aria-hidden
      />
      <span>: 기초 시간표에서 변경된 영역</span>
    </li>
    <li data-tutorial-neis-legend="dedicated-mismatch">
      <span
        className="cp-weekly-learning-guide-neis-legend-swatch cp-weekly-learning-guide-neis-legend-swatch--dedicated-mismatch"
        aria-hidden
      />
      <span>: 기초 시간표와 같은 편제이나 색상(전담 과목 등)이 다른 영역</span>
    </li>
    <li data-tutorial-neis-legend="unregistered">
      <span>
        <span className="cp-weekly-learning-guide-neis-legend-sample-text">텍스트</span> : 편제에 등록되지 않은 시간표
      </span>
    </li>
    <li data-tutorial-neis-legend="short-edge">
      <span
        className="cp-weekly-learning-guide-neis-legend-swatch cp-weekly-learning-guide-neis-legend-swatch--short-edge"
        aria-hidden
      />
      <span>: 요일별 기준 수업시수에서 삭제 또는 추가된 영역</span>
    </li>
  </ul>
);

export default WeeklyLearningGuideNeisLegend;
